import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/features/landing/components/CategoryTabs.jsx");
